import script from "./CodesList.vue?vue&type=script&lang=ts&setup=true"
export * from "./CodesList.vue?vue&type=script&lang=ts&setup=true"

import "./CodesList.vue?vue&type=style&index=0&id=55994079&lang=scss"

const __exports__ = script;

export default __exports__
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QList,QItem,QIcon});
